import { defineMeta } from '@/registry/types';

export const avatarMeta = defineMeta({
  name: 'Avatar',
  level: 'atom',
  category: 'data-display',
  classification: 'themed-mui',
  description: 'Represents a user or entity via image, initials or icon. Themed MUI Avatar.',
  baseLibrary: '@mui/material',
  muiEquivalent: 'Avatar',
  muiDocs: 'https://mui.com/material-ui/react-avatar/',
  a2uiEquivalent: 'Avatar',
  importPath: '@/atoms/Avatar',
  optionalProps: ['src', 'alt', 'variant', 'children', 'sx'],
  supportedStates: ['image', 'initials', 'icon', 'fallback'],
  designTokens: ['colors', 'radius'],
  accessibility: ['Always set alt for image avatars; initials should reflect the entity name.'],
  usageExamples: ['<Avatar src="/u.png" alt="Jane" />', '<Avatar>JS</Avatar>'],
  rules: [
    'An avatar is a neutral control fill two rungs above its host, carrying primary text. It reads its own colour from the surface it is on, so there is nothing to pass in.',
    'Two rungs, not one, because one rung up is what a nested card takes - an avatar there would read as a small panel rather than as an identity mark.',
    'If you override bgcolor with a saturated colour, set color as well. The default ink is light, and light ink on brand teal is 1.89:1. Pair the fill with its own contrastText.',
  ],
  antiPatterns: [
    'Do not omit alt on image avatars.',
    'Do not set bgcolor from the brand to make an avatar stand out. Brand marks the primary action and the current selection; an identity mark is neither.',
  ],
  llmSafe: true,
  whenToUse: ['Showing user/entity identity'],
  whenNotToUse: ['Decorative icons (use Icon)'],
});

export default avatarMeta;
